export default __webpack_public_path__ + "static/media/fotoPa.e230df70.png";